import { useCallback } from 'react';
import { useModal } from 'src/shared/modalProvider';
import { AUTH_OTP_CODE_MODAL_NAME } from './const';
import { AuthOTPCodeModalProps } from './types';

export const useOTPCodeModalProvider = () => {
  const { openModal } = useModal();
  return useCallback(
    (props: AuthOTPCodeModalProps): Promise<void> =>
      new Promise((resolve) => {
        openModal(AUTH_OTP_CODE_MODAL_NAME, {
          ...props,
          onModalDestroy: () => resolve(),
        });
      }),
    [openModal],
  );
};
